import { render } from "./ChargebeeUpsellSettingsSummary.vue?vue&type=template&id=c15d57ae&scoped=true"
import script from "./ChargebeeUpsellSettingsSummary.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellSettingsSummary.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellSettingsSummary.vue?vue&type=style&index=0&id=c15d57ae&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c15d57ae"]])

export default __exports__